import { type PlatformCommunity } from "@forento/shared/models/platform"
import { type PlatformUser } from "@forento/shared/models/user"

export function hasAccessToViewCommunity(user: PlatformUser, community: PlatformCommunity): boolean {
	if (user.isCreator) return true
	if (community.all) return true
	if (user.membership) return community.membershipIds.includes(user.membership.id)
	return false
}
